exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-mobile .card .wrapper .header .first-col.details[data-v-22e9d270] {\n  width: 90%;\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: rgba(6, 38, 62, 0.74);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.container-mobile .card .wrapper .header .second-col.details[data-v-22e9d270] {\n  width: 10%;\n}\n.full-name[data-v-22e9d270]:after {\n  content: '\\A';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #3c7442;\n  display: inline-block;\n  margin: 0 8px;\n}\n", ""]);

// exports
